// Simple fuzzy match - returns similarity score (0-1, higher is better)
export function fuzzyMatch(search: string, target: string): number {
  const s = search.toLowerCase();
  const t = target.toLowerCase();

  // Exact match
  if (s === t) return 1;

  // Contains check
  if (t.includes(s)) return 0.8;

  // Simple edit distance (count matching characters in order)
  let matches = 0;
  let searchIdx = 0;
  for (let i = 0; i < t.length && searchIdx < s.length; i++) {
    if (t[i] === s[searchIdx]) {
      matches++;
      searchIdx++;
    }
  }

  const score = matches / Math.max(s.length, t.length);
  return score;
}

// Find the best fuzzy match from a list of candidates
export function findBestFuzzyMatch(
  search: string,
  candidates: Array<{
    symbol: string;
    abbr: string;
    displayAbbr: string;
    displayName: string;
  }>,
  minScore = 0.5,
): string | null {
  if (!search || search.length < 2) return null;

  let bestMatch = { symbol: '', abbr: '', displayAbbr: '', score: 0 };

  candidates.forEach(({ symbol, abbr, displayName, displayAbbr }) => {
    const abbrScore = fuzzyMatch(search, abbr);
    const displayAbbrScore = fuzzyMatch(search, displayAbbr);
    const nameScore = fuzzyMatch(search, displayName);
    const score = Math.max(abbrScore, displayAbbrScore, nameScore);

    if (score > bestMatch.score && score < 1) {
      // < 1 means not exact match
      bestMatch = { symbol, abbr, displayAbbr, score };
    }
  });

  // Only suggest if score is decent
  return bestMatch.score > minScore ? bestMatch.displayAbbr : null;
}
